import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DeactivateGuard } from '../../shared/guards/candeactivate';
import { VinLookupComponent } from './vin-lookup.component';

const routes: Routes = [
  {
    path: '',
    component: VinLookupComponent,
    canDeactivate: [DeactivateGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VinLookupRoutingModule { }
